var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Injectable, Optional } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DeService } from '@synisys/idm-de-service-client-js';
import { FormService, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { FormResolverService } from '@synisys/idm-frontend-shared';
import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { DynamicFormComponent } from '../../component';
import { ContextArg, ContextArgEnum, StateArg, } from '../layout-actions/dynamic-argument.type';
import { ActionBuilder, } from '../layout-actions/layout-action.builder';
import { TabIndexService } from './tab-index.service';
import { KbService } from '@synisys/idm-kb-service-client-js';
import { checkEntityExists } from '../utils';
import { DefaultFormResolverService } from './default-form-resolver.service';
import { of } from 'rxjs/observable/of';
var DynamicFormNavigationsService = /** @class */ (function () {
    function DynamicFormNavigationsService(formResolverService, formService, route, deService, kbService, tabIndexService, defaultFormResolverService) {
        this.formResolverService = formResolverService;
        this.formService = formService;
        this.route = route;
        this.deService = deService;
        this.kbService = kbService;
        this.tabIndexService = tabIndexService;
        this.defaultFormResolverService = defaultFormResolverService;
    }
    DynamicFormNavigationsService.prototype.toEdit = function (form, formName, categoryName, entityId, formId) {
        var _this = this;
        if (formId === void 0) { formId = 0; }
        return checkEntityExists(this.kbService, this.deService, categoryName, entityId)
            .pipe(switchMap(function () { return _this.tabIndexService.tabIndexObservable(); }), switchMap(function (tabId) {
            return _this.formResolverService.navigateToEditDeForm(categoryName, formName, entityId, formId, DynamicFormComponent.QUERY_PARAMS, String(tabId));
        }), take(1))
            .catch(function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
                return Observable.of(false);
            }
        })
            .toPromise();
    };
    DynamicFormNavigationsService.prototype.toDefaultEditForm = function (form, categoryName, entity) {
        var _this = this;
        return checkEntityExists(this.kbService, this.deService, categoryName, entity.getInstanceId())
            .pipe(switchMap(function () {
            return zip(_this.formService.allFormsByCategoryAndType(categoryName, FormType.EDIT), _this.tabIndexService.tabIndexObservable());
        }), switchMap(function (_a) {
            var formData = _a[0], tabId = _a[1];
            var firstForm = formData[0];
            return _this.formResolverService.navigateToEditDeForm(categoryName, firstForm.model.formName, entity.getInstanceId(), firstForm.id, DynamicFormComponent.QUERY_PARAMS, String(tabId));
        }), take(1))
            .catch(function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
                return Observable.of(false);
            }
        })
            .toPromise();
    };
    DynamicFormNavigationsService.prototype.toDefaultViewForm = function (form, categoryName, entity) {
        var _this = this;
        return checkEntityExists(this.kbService, this.deService, categoryName, entity.getInstanceId())
            .pipe(switchMap(function () {
            return zip(_this.getDefaultForm(categoryName, entity), _this.tabIndexService.tabIndexObservable());
        }), switchMap(function (_a) {
            var defaultForm = _a[0], tabId = _a[1];
            return _this.formResolverService.navigateToViewDeForm(categoryName, defaultForm && defaultForm.formName, entity.getInstanceId(), defaultForm && defaultForm.formId, DynamicFormComponent.QUERY_PARAMS, String(tabId));
        }), take(1), catchError(function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
                return Observable.of(false);
            }
        }))
            .toPromise();
    };
    DynamicFormNavigationsService.prototype.toView = function (form, formName, categoryName, entityId, formId) {
        var _this = this;
        if (formId === void 0) { formId = 0; }
        return checkEntityExists(this.kbService, this.deService, categoryName, entityId)
            .pipe(switchMap(function () { return _this.tabIndexService.tabIndexObservable(); }), switchMap(function (tabId) {
            return _this.formResolverService.navigateToViewDeForm(categoryName, formName, entityId, formId, DynamicFormComponent.QUERY_PARAMS, String(tabId));
        }), take(1))
            .catch(function (err) {
            if (err.status === 404) {
                form.publishEvent('de_entity_already_deleted', 'Error', 'de_save_error_mode');
                return Observable.of(false);
            }
        })
            .toPromise();
    };
    DynamicFormNavigationsService.prototype.getActions = function () {
        var _this = this;
        var result = [];
        result.push(new ActionBuilder()
            .name('toEdit')
            .params([
            ContextArg(ContextArgEnum.FORM),
            StateArg('formName'),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY_ID),
            StateArg('formId'),
        ])
            .action(function (form, formName, categoryName, entityId, formId) {
            if (formId === void 0) { formId = 0; }
            return _this.toEdit(form, formName, categoryName, entityId, formId);
        })
            .build());
        result.push(new ActionBuilder()
            .name('toDefaultEditForm')
            .params([
            ContextArg(ContextArgEnum.FORM),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY),
        ])
            .action(function (form, categoryName, entity) { return _this.toDefaultEditForm(form, categoryName, entity); })
            .build());
        result.push(new ActionBuilder()
            .name('toDefaultViewForm')
            .params([
            ContextArg(ContextArgEnum.FORM),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY),
        ])
            .action(function (form, categoryName, entity) { return _this.toDefaultViewForm(form, categoryName, entity); })
            .build());
        result.push(new ActionBuilder()
            .name('toDefaultViewForm')
            .params([
            ContextArg(ContextArgEnum.FORM),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY),
        ])
            .action(function (form, categoryName, entity) { return _this.toDefaultViewForm(form, categoryName, entity); })
            .build());
        result.push(new ActionBuilder()
            .name('toView')
            .params([
            ContextArg(ContextArgEnum.FORM),
            StateArg('formName'),
            ContextArg(ContextArgEnum.CATEGORY),
            ContextArg(ContextArgEnum.ENTITY_ID),
            StateArg('formId'),
        ])
            .action(function (form, formName, categoryName, entityId, formId) {
            if (formId === void 0) { formId = 0; }
            return _this.toView(form, formName, categoryName, entityId, formId);
        })
            .build());
        return result;
    };
    DynamicFormNavigationsService.prototype.getDefaultForm = function (categoryName, entity, formType) {
        var _this = this;
        if (formType === void 0) { formType = FormType.VIEW; }
        if (this.defaultFormResolverService) {
            return this.defaultFormResolverService
                .getForm(categoryName, entity, formType)
                .pipe(switchMap(function (defaultForm) {
                return defaultForm
                    ? of(defaultForm)
                    : _this.loadFirstForm(categoryName, formType);
            }));
        }
        return this.loadFirstForm(categoryName, formType);
    };
    DynamicFormNavigationsService.prototype.loadFirstForm = function (categoryName, formType) {
        return this.formService
            .allFormsByCategoryAndType(categoryName, formType)
            .pipe(map(function (allForms) {
            if (allForms.length) {
                return {
                    formId: allForms[0].id,
                    formName: allForms[0].model.formName,
                };
            }
        }));
    };
    DynamicFormNavigationsService = __decorate([
        Injectable(),
        __param(6, Optional()),
        __metadata("design:paramtypes", [FormResolverService,
            FormService,
            ActivatedRoute,
            DeService,
            KbService,
            TabIndexService,
            DefaultFormResolverService])
    ], DynamicFormNavigationsService);
    return DynamicFormNavigationsService;
}());
export { DynamicFormNavigationsService };
//# sourceMappingURL=dynamic-form-navigations.service.js.map